import React = require("react");
import Paper from 'material-ui/Paper';
import { colors } from 'material-ui/styles';

import { autoprefixer } from "../material-ui/autoprefixer";
import WarnIcon from "material-ui/svg-icons/alert/warning";

interface WarningProps {
    text: string;
    isError?: boolean;
}

export default class Warning extends React.Component<WarningProps, {}> {
    render() {
        const style = this.getStyle();
        return (
            <Paper style={style.root}>
                <WarnIcon style={style.warnIcon} />
                { this.props.text }
            </Paper>
        );
    }

    private getStyle() {
        return {
            root: autoprefixer({
                // TODO use color from theme pallete
                backgroundColor: this.props.isError ? colors.red100 : colors.blue50,
                padding: 12,
                fontSize: 12,
                opacity: 0.54,
                fontWeight: 600,
                display: "flex",
                alignItems: "center",
                marginTop: 4
            }),
            warnIcon: {
                height: 16,
                marginRight: 10
            }
        };
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/components/Warning.tsx
 **/